<template>
    <div class="contentblock">
        <section class="contentblock__content">
            <div class="shop__fieldgroup shop__fieldgroup--no-separator">
                <div class="migrol-rt-content" v-html="Strings['Shop.Errors.GenericErrorPage']"></div>
                <button class="migrol-form__button migrol-form__button--green" @click="startOver">
                    <span class="migrol-form__button-label">{{Strings['Shop.OfferRestart']}}</span>
                </button>
            </div>
        </section>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        computed: {
            ...mapState([
                'Strings'
            ])
        },
        methods: {
            startOver() {
                this.$router.push('/').catch(() => { });
            }
        }
    };
</script>